/** Caps vehicles of interest carried in the interest context slice. */
export const ASSISTANT_INTEREST_VEHICLES_MAX_ITEMS = 5;
